if(!customElements.get('announcement-slider')) {
  customElements.define('announcement-slider', class AnnouncementSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector(`#${this.sectionID}`);
      if(!this.slider) return;
      this.initSlider();
    }

    get sectionID () {
      return this.dataset.sectionId;
    }

    initSlider() {
      const options = {
        speed: 400,
        slidesPerView: 1,
        slidesPerMove: 1,
        freeModeMomentum: false,
        allowTouchMove: false,
        pagination: false,
        navigation: false,
        resistance: false,
        loop: true,
        autoplay: {
          delay: 4000,
        },
      };

      const slider = new Swiper(this.slider, options);
    }
  })
}